// extracted by mini-css-extract-plugin
module.exports = {"root":"LookBoardDragModal_root__tMpBm","closeBtn":"LookBoardDragModal_closeBtn__18ykx","img":"LookBoardDragModal_img__2FXY6","resizeIcon":"LookBoardDragModal_resizeIcon__lzTf7"};